import { useRef, useState } from 'react';
import { Copy, Share2 } from 'lucide-react';

export default function ShareContact() {
  const [nativeAvailable, setNativeAvailable] = useState(() => typeof navigator.share === 'function');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const inFlight = useRef(false);

  const share = async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    setMessage('');
    // Share the current landing, not tracking parameters or the section/privacy hash.
    const url = new URL(window.location.pathname, window.location.origin).href;
    const data = {
      title: 'Marco Ghelli | MG Digital Solution',
      text: 'Marco Ghelli\nMG Digital Solution\nAI Solutions & App Designer',
      url
    };
    try {
      if (nativeAvailable && typeof navigator.share === 'function') {
        try {
          await navigator.share(data);
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
          // An iframe/browser permission can block native sharing despite feature detection.
          setNativeAvailable(false);
        }
      }
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(url);
          setMessage('Link copiato. Puoi incollarlo dove preferisci.');
          return;
        } catch {
          // Do not claim the clipboard was updated when access is denied.
        }
      }
      setMessage('Copia non disponibile in questo browser. Puoi copiare il link dalla barra degli indirizzi.');
    } finally {
      inFlight.current = false;
      setBusy(false);
    }
  };

  return <div className="share-contact">
    <button type="button" className="share-contact-button" data-testid="share-contact" onClick={share} disabled={busy} aria-describedby={message ? 'share-feedback' : undefined}>
      {nativeAvailable ? <Share2 size={16} /> : <Copy size={16} />}
      {nativeAvailable ? 'Condividi' : 'Copia link'}
    </button>
    <p className="share-contact-feedback" id="share-feedback" data-testid="share-feedback" role="status" aria-live="polite">{message}</p>
  </div>;
}
